import { useId } from 'react'

export default function AgentWorkflow() {
  const gid = useId().replace(/[^a-zA-Z0-9]/g, '')
  const grad = `grad_${gid}`
  const glow = `glow_${gid}`
  const blur = `blur_${gid}`
  return (
    <div className="wf">
      <svg className="wf-svg" viewBox="0 0 1000 360" role="img" aria-label="Agents building value">
        <defs>
          <linearGradient id={grad} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="var(--brand)" />
            <stop offset="100%" stopColor="#6fb1ff" />
          </linearGradient>
          <filter id={glow} x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="6" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter id={blur} x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2" />
          </filter>
        </defs>

        {/* subtle grid */}
        <g opacity=".18">
          {Array.from({ length: 9 }).map((_, i) => (
            <line key={`vg${i}`} x1={(i+1)*100} y1={40} x2={(i+1)*100} y2={320} stroke="var(--border)" strokeWidth="1" />
          ))}
          {Array.from({ length: 4 }).map((_, i) => (
            <line key={`hg${i}`} x1={80} y1={80 + i*70} x2={920} y2={80 + i*70} stroke="var(--border)" strokeWidth="1" />
          ))}
        </g>

        {/* paths: input -> agents -> value */}
        <g className="wf-paths">
          {/* input to agents */}
          <path className="wf-path wf-dash" d="M160 180 C 230 180, 300 140, 360 130" stroke={`url(#${grad})`} />
          <path className="wf-path wf-dash" d="M160 180 C 230 180, 300 220, 360 230" stroke={`url(#${grad})`} />
          <path className="wf-path wf-dash" d="M160 180 C 250 180, 300 180, 420 180" stroke={`url(#${grad})`} />
          {/* agents to value */}
          <path className="wf-path wf-dash" d="M480 130 C 640 120, 760 140, 840 180" stroke={`url(#${grad})`} />
          <path className="wf-path wf-dash" d="M480 230 C 640 240, 760 220, 840 180" stroke={`url(#${grad})`} />
          <path className="wf-path wf-dash" d="M540 180 C 670 180, 740 180, 840 180" stroke={`url(#${grad})`} />
        </g>

        {/* input node */}
        <g className="wf-card" transform="translate(80, 150)">
          <rect rx="12" width="120" height="60" fill="var(--panel)" stroke="var(--border)" />
          <text x="60" y="36" textAnchor="middle" className="wf-label">Inputs</text>
        </g>

        {/* agent nodes */}
        <g className="wf-agent" transform="translate(360,130)">
          <circle r="18" cx="0" cy="0" className="wf-node" />
          <circle r="30" cx="0" cy="0" className="wf-pulse" />
          <text x="0" y="5" textAnchor="middle" className="wf-sigil">∫</text>
        </g>
        <g className="wf-agent" transform="translate(420,180)">
          <circle r="18" cx="0" cy="0" className="wf-node" />
          <circle r="30" cx="0" cy="0" className="wf-pulse" />
          <text x="0" y="5" textAnchor="middle" className="wf-sigil">∫</text>
        </g>
        <g className="wf-agent" transform="translate(480,230)">
          <circle r="18" cx="0" cy="0" className="wf-node" />
          <circle r="30" cx="0" cy="0" className="wf-pulse" />
          <text x="0" y="5" textAnchor="middle" className="wf-sigil">∫</text>
        </g>

        {/* value card */}
        <g className="wf-card wf-value" transform="translate(820, 150)">
          <rect rx="14" width="120" height="60" fill="var(--panel)" stroke="var(--border)" filter={`url(#${glow})`} />
          <g transform="translate(16,16)">
            <rect width="8" height="28" x="0" y="16" fill="url(#grad)" opacity="0.7" />
            <rect width="8" height="34" x="16" y="10" fill="url(#grad)" opacity="0.85" />
            <rect width="8" height="40" x="32" y="4" fill="url(#grad)" />
            <text x="78" y="34" textAnchor="middle" className="wf-value-text">$</text>
          </g>
        </g>

        {/* floating particles */}
        <g className="wf-particles" opacity=".8">
          {Array.from({ length: 10 }).map((_, i) => (
            <circle key={i} className={`wf-bit wf-bit-${i%5}`} cx={120 + (i*80)%760} cy={80 + (i*50)%200} r="2" fill="url(#grad)" filter={`url(#${blur})`} />
          ))}
        </g>
      </svg>
    </div>
  )
}

